export default [
  {
    path: '/',
    redirect: {
      name: 'home'
    }
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    meta: {
      name: '首页',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/home')
  },
  // 解决方案
  {
    path: '/interaction',
    name: 'interaction',
    meta: {
      name: '解决方案交互型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/interaction')
  },
  {
    path: '/practice',
    name: 'practice',
    meta: {
      name: '解决方案实践型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/practice')
  },
  {
    path: '/network',
    name: 'network',
    meta: {
      name: '解决方案网络型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/network')
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      name: '解决方案演示型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/demo')
  },
  {
    path: '/solution',
    name: 'solution',
    meta: {
      name: '解决方案',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution-zjm.vue')
  },
  {
    path: '/discussion',
    name: 'discussion',
    meta: {
      name: '研讨型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/discussion.vue')
  },
  {
    path: '/standard',
    name: 'standard',
    meta: {
      name: '标准型',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/solution/standard.vue')
  },
  // // 基础方案
  // {
  //   path: '/K12plan',
  //   name: 'K12plan',
  //   meta: {
  //     name: '基础方案',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/K12plan')
  // },
  // {
  //   path: '/math',
  //   name: 'math',
  //   meta: {
  //     name: '数学',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/k12/math.vue')
  // },
  // {
  //   path: '/english',
  //   name: 'english',
  //   meta: {
  //     name: '英语',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/k12/english.vue')
  // },
  // {
  //   path: '/calligraphy',
  //   name: 'calligraphy',
  //   meta: {
  //     name: '书法',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/k12/calligraphy.vue')
  // },
  // {
  //   path: '/lihuasheng',
  //   name: 'lihuasheng',
  //   meta: {
  //     name: '理化生',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/k12/lihuasheng.vue')
  // },
  // {
  //   path: '/arts',
  //   name: 'arts',
  //   meta: {
  //     name: '美术',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/k12/arts.vue')
  // },
  {
    path: '/product-system',
    name: 'product-system',
    meta: {
      name: '智能语言训练系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/product-system.vue')
  },
  {
    path: '/product-number',
    name: 'product-number',
    meta: {
      name: '数字语言系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/product-number.vue')
  },
  {
    path: '/padAdmin',
    name: 'padAdmin',
    meta: {
      name: '平板云管理',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/pad-administration.vue')
  },
  {
    path: '/padSteal',
    name: 'padSteal',
    meta: {
      name: '平板云防盗',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/pad-steal.vue')
  },
  // 产品介绍
  {
    path: '/productmain',
    name: 'productmain',
    meta: {
      name: '产品介绍',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/productmain.vue')
  },
  {
    path: '/classhub',
    name: 'classhub',
    meta: {
      name: '智慧教室司令官',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/classhubnew.vue')
  },
  {
    path: '/trainCart',
    name: 'trainCart',
    meta: {
      name: '移动示教推车',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/trainCart.vue')
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      name: '智慧教室司令官',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/test.vue')
  },
  {
    path: '/roombox',
    name: 'roombox',
    meta: {
      name: '教室云盒',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/roombox.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      name: '互动反馈器',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/feedback.vue')
  },
  {
    path: '/simultaneous_interpret_restore',
    name: 'simultaneous_interpret_restore',
    meta: {
      name: '同时翻译还原系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/simultaneous_interpret_restore.vue')
  },
  {
    path: '/desktopCloud',
    name: 'desktopCloud',
    meta: {
      name: '桌面云系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/desktopCloud.vue')
  },
  {
    path: '/eleSystem',
    name: 'eleSystem',
    meta: {
      name: '电子教室系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/electronic-classroom.vue')
  },
  {
    path: '/mediaSystem',
    name: 'mediaSystem',
    meta: {
      name: '电子书包系统',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/media-interaction.vue')
  },
  {
    path: '/smartCampus',
    name: 'smartCampus',
    meta: {
      name: '智慧校园方案',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/product/smartCampus.vue')
  },
  {
    path: '/salesPromotion',
    name: 'salesPromotion',
    meta: {
      name: '促销活动',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/activity/salesPromotion.vue')
  },
  {
    path: '/feitian',
    name: 'feitian',
    meta: {
      name: '飞天计划',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/cooperation/feitian.vue')
  },
  {
    path: '/lighthouse',
    name: 'lighthouse',
    meta: {
      name: '灯塔计划',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/cooperation/lighthouse.vue')
  },
  // {
  //   path: '/manufacturers',
  //   name: 'manufacturers',
  //   meta: {
  //     name: '厂商合作',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/cooperation/manufacturers.vue')
  // },
  // {
  //   path: '/channel',
  //   name: 'channel',
  //   meta: {
  //     name: '渠道合作',
  //     hideInStage: true,
  //     hideInMenu: true,
  //     notCache: true
  //   },
  //   component: () => import('../views/cooperation/channel.vue')
  // },
  // 联系购买
  {
    path: '/contact',
    name: 'contact',
    meta: {
      name: '联系购买',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/contact/index.vue')
  },
  // 关于极域
  {
    path: '/knowMythware',
    name: 'knowMythware',
    meta: {
      name: '了解极域',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/knowmythware/index.vue')
  },
  {
    path: '/support',
    name: 'support',
    meta: {
      name: '技术支持',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/support/index.vue')
  },
  {
    path: '/job',
    name: 'job',
    meta: {
      name: '技术支持',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/job/index.vue')
  },
  {
    path: '/news',
    name: 'news',
    meta: {
      name: '新闻中心',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/news/index.vue')
  },
  {
    path: '/downloadArea',
    name: 'downloadArea',
    meta: {
      name: '下载专区',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/downloadArea/index.vue')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    meta: {
      name: '新闻中心',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/news/detail.vue')
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      name: '服务案例',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/service/index.vue')
  },
  {
    path: '/law',
    name: 'law',
    meta: {
      name: '法律声明',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/law/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: {
      name: '隐私条款',
      hideInStage: true,
      hideInMenu: true,
      notCache: true
    },
    component: () => import('../views/mythware/privacy/index.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    meta: {
      name: '公众号'
    },
    component: () => import('../views/public/activity/index.vue')
  },
  {
    path: '/classhub_download',
    name: 'classhub_download',
    meta: {
      name: '文件下载'
    },
    component: () => import('../views/public/classhub_download/index.vue')
  }
  // {
  //   path: '/classhub_download',
  //   name: 'classhub_download',
  //   meta: {
  //     name: '文件下载'
  //   },
  //   component: () => import('../views/public/classhub_download/down.vue')
  // }
]



// WEBPACK FOOTER //
// ./src/router/router.js